import React from 'react';

import type { IconSize } from '../../../../types/icons';
import { ButtonInner } from '../ButtonInner/ButtonInner';
import * as styles from './styles';
import type { IconButtonProps, IconButtonSize } from './types';

const ICON_BUTTON_SIZE_MAP: Record<IconButtonSize, Exclude<IconSize, 32 | 20>> = {
  small: 16,
  large: 24,
};

/**
 * IconButton takes an icon component as a prop and returns a rounded button with the centered icon
 */
export const IconButton = ({
  Icon,
  active,
  brandColorMode,
  displayBorder,
  size,
  ...props
}: IconButtonProps) => {
  const iconSize = ICON_BUTTON_SIZE_MAP[size];
  const getIconColor = () => {
    if (props.disabled) {
      return 'var(--neutral-black-70)';
    }

    if (brandColorMode) {
      return 'var(--brand-purple-base)';
    }

    return undefined;
  };

  return (
    <button
      css={[
        size === 'small' ? styles.small : styles.large,
        styles.iconButton,
        brandColorMode && styles.brandStyles,
        displayBorder && styles.borderStyles,
      ]}
      data-is-active={active}
      {...props}
    >
      <ButtonInner>
        <Icon color={getIconColor()} height={iconSize} width={iconSize} />
      </ButtonInner>
    </button>
  );
};
